import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareBoardsCsmRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareBoardsCsmRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import CsmPage, { LazyCsmSettings } from './ui/project-settings/csm/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsSoftwareBoardsCsmRouteEntry: Route = createEntry(
	projectSettingsSoftwareBoardsCsmRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
		// eslint-disable-next-line no-restricted-syntax
		component: CsmPage,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyCsmSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
